/**
 * 多版本菜单 B6（老扫码站 U-B6-3，owner D98②）：地址里有形状合法的预览码 ⇒ 页面上的下单 / 开挂账 / 付款入口本地拦住。这是**第一道**。
 *
 * 调用方（`stopOrderingForPreview` 五个页面七处；`isOrderingBlockedByPreview` 另有四个页面六处，含 venue-home）：
 * - 三个结账按钮：单店购物车（`views/cart` `checkCurrentTabOwner`）、合单购物车（`views/venue-sub-group/cart` `checkOrderProcess`，
 *   D98①：合单页带码也本地拦）、开挂账页（`views/tab-user/start-tab` `validateForm`）。按钮变灰（三页的 `previewOrderBlocked` 计算属性）、
 *   旁边写 D56 那句原因（`Preview — orders can't be placed`），万一还是点到了（按钮状态没来得及更新）就弹同一句、什么都不做；
 * - 付款页（`views/payment` `mounted` + `clickButton`，U-B6-2 review 第 1 轮 F9）与卡页（`views/card-detail` `mounted` + `handleSubmit`，
 *   第 2 轮 G11）一进来就停：付款页的 Apple Pay、卡页的 Windcave AJAX 提交用的是全局 axios，请求层（第二道）看不见，只能在页面上拦；
 * - 不是拦单、只是「预览页上不做」：购物车页与 venue-home 的 D97 本地核对（草稿菜单不标真购物车，第 2 轮 G6）、
 *   venue-home `_setupSubGroup`（预览入口清掉上一次合单留下的 subGroupId，第 2 轮 G5）。
 * 第二道在请求层：后端没有预览闸的写接口本地拦下不发（`previewRequest.js`，兜住挂账页快捷付款、开挂账页预授权等页面漏掉的入口），
 * 单店 add-order 带着 X-Preview-Menu 发出去、后端拒（D80）。
 *
 * 「预览已结束」（D88）之后照样拦：地址里还带着码，下单请求照样带头、后端照样拒 —— 见 `previewMenuStatus.js`。
 */
import { currentPreviewMenuToken } from './previewMenu'
import { previewOrdersDisabledText } from './previewMenuCopy'
import { createMessageDialog } from '@/utils/request/messageDialog'

/** 这一页能不能下单：地址（或路由 query）里有形状合法的预览码就不能。`route` 传 `this.$route`，组件里放进 computed 才会随跳转重算 */
export function isOrderingBlockedByPreview(route) {
  return currentPreviewMenuToken(route && route.query) !== null
}

/** 点了结账：预览中 ⇒ 弹 D56 那句、返回 true（调用方就此停下）；否则返回 false 照常往下走 */
export function stopOrderingForPreview(route) {
  if (!isOrderingBlockedByPreview(route)) return false
  createMessageDialog(previewOrdersDisabledText())
  return true
}
